
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[id]",
      function () {
        return require("private-next-pages/posts/[id]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/[id]"])
      });
    }
  